import { hostsConfig } from '@openeducation/oe-it-services';
import type { Environment } from '@openeducation/oe-it-services';
import axios from 'axios';

import type { MessageNotification } from '../../interfaces/message-notification';

export default abstract class MessageDao {
  static async getMessage(
    env: Environment,
    teacherId: number,
    page: number,
    itensPerPage: number,
    sortParm: string
  ) {
    const url = hostsConfig[env].notificationServiceUrl;

    const { data } = await axios.get(
      `${url}/notifications/${teacherId}/${page}/${itensPerPage}/${sortParm}`
    );

    return data;
  }
  static async remove(
    env: Environment,
    notificationId: string,
    teacherId: number
  ) {
    const url = hostsConfig[env].notificationServiceUrl;
    const { data } = await axios.put(
      `${url}/notifications/delete/${notificationId}/${teacherId}`
    );

    return data;
  }
  static async create(env: Environment, message: MessageNotification) {
    const url = hostsConfig[env].notificationServiceUrl;
    const { roles, ...props } = message;

    const { data } = await axios.post(
      `${url}/notifications/groups?roleId=${roles}`,
      props
    );

    return data;
  }
}
